/* istanbul ignore file */
const timeZoneName = (format) => {
  const dtf = Intl.DateTimeFormat(undefined, { timeZoneName: format });
  return dtf.formatToParts(new Date()).find(part => part.type === 'timeZoneName').value;
};

const shortName = () => timeZoneName('short');
const longName = () => timeZoneName('long');
const shorterName = () => {
  return timeZoneName('short')
    .replace(/HST|HDT/g, 'HT')
    .replace(/PST|PDT/g, 'PT')
    .replace(/MST|MDT/g, 'MT')
    .replace(/CST|CDT/g, 'CT')
    .replace(/EST|EDT/g, 'ET');
};

export default { shortName, shorterName, longName };
